import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { BonificoOrderDTO } from "./BonificoOrderDTO.ts";

export function useUpdateBonificoOrderNotes() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const updateNotes = async (
    orderId: string,
    notes: string,
  ): Promise<BonificoOrderDTO> => {
    setLoading(true);
    try {
      const { data } = await createAxiosInstance().put<BonificoOrderDTO>(
        `/bonifico-orders/${orderId}/notes`,
        { notes },
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { updateNotes, loading };
}
